$(".team-accordion .nav-tabs a").click(function() {
    var position = $(this).parent().position();
    var width = $(this).parent().width();
    $(".team-accordion .slider").css({"left":+ position.left,"width":width});
});


$(document).ready(function(){
    var actWidth = $(".nav-tabs").find("li.active").width();
    var actPosition = $(".nav-tabs li.active").position();
    $(".slider").css({"left": actPosition.left,"width": actWidth});
});